module.exports = __webpack_public_path__ + "img/levo.dc2c5b2a.svg";